<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading :title="`${sample_type.name} Details`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read sample type'">
      <template #gated-content>
        <sample-type-card :sample_type="sample_type" />

        <SampleTypeAnalyteRangeForm :sample_type="sample_type" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup"
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import SampleTypeCard from "@/components/lab/sampletype/SampleTypeCard"
import { getModel } from '@/shared/fetch-utils'
import SampleTypeAnalyteRangeForm from '@/components/lab/sampletype/SampleTypeAnalyteRangeForm.vue'

export default {
  name: "SampleTypeAnalyteRange",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleTypeCard,
    SampleTypeAnalyteRangeForm
  },
  data () {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type: null,
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/sampletypes",
            title: "Sample Type list",
          },
          {
            icon: "fa-eye",
            linkto: `/sampletypes/${this.sample_type_id}`,
            title: "View Sample Type",
            variant: "info",
          }
        ],
      }
    },
  },
  async created () {
    this.loading = true

    this.sample_type = await getModel({
      model_type: "sample_type",
      id: this.sample_type_id,
      message: this.$bvToast,
    })

    this.sample_type ? (this.loading = false) : this.$router.back()
  },
  methods: {
    submit () {}
  }
}
</script>
